import { ISODatetime } from '@models/date';
import { HistoryItem } from '@models/history';
import isTruthy from '@util/isTruthy';
import z from 'zod';

export const Auditable = z.object({
  createdOn: ISODatetime.nullish(),
  modifiedOn: ISODatetime.nullish(),
  deletedOn: ISODatetime.nullish(),
  history: z
    .array(HistoryItem.nullable())
    .transform((history) => history.filter(isTruthy))
    .nullish(),
  v: z.number().nullish(),
});
